<template>
  <Modal :show="showModal" hide-buttons @close="showModal = false">
    <BoxedSvgIcon icon="Star" color="orange" class="-mt-16 mb-2" />
    <div class="text-center text-lg font-semibold">
      {{ $t('ui.ai_suggestions.pending_entities_title') }}
    </div>
    <p class="text-center text-secondary text-base mt-1 mb-6">
      {{ $t('ui.ai_suggestions.pending_entities_count', entities.length) }}
    </p>

    <div
      class="bg-background rounded-md max-h-72 overflow-y-auto scroll-page divide-y divide-outline"
    >
      <div
        v-for="entity in entities"
        :key="entity.id"
        class="flex items-center justify-between gap-4 px-4 py-3"
      >
        <div class="min-w-0">
          <div class="font-semibold truncate">{{ entity.name }}</div>
          <div class="text-secondary text-xs">
            {{
              $t(
                'ui.ai_suggestions.pending_suggestions_count',
                entity.pending_count
              )
            }}
          </div>
        </div>
        <Button
          size="sm"
          type="secondary"
          :to="{
            name: 'AssetsPortfolioView',
            query: {
              entity_id: entity.id,
              section: 'ai-suggestions',
              action: 'open',
            },
          }"
          @click="review($event, entity.id)"
        >
          {{ $t('ui.ai_suggestions.review') }}
        </Button>
      </div>
    </div>

    <div class="flex justify-end mt-6">
      <Button type="secondary" @click="showModal = false">
        {{ $t('ui.ai_suggestions.later') }}
      </Button>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useUserStore } from '@/stores/user'
import Button from '@/components/controls/Button'
import Modal from '@/components/misc/Modal'
import { BoxedSvgIcon } from '@/components/misc/SvgIcon'
import { useAiSuggestionsNotification } from '../composables/ai_suggestions_notification'

const userStore = useUserStore()
const { entities } = useAiSuggestionsNotification()

const showModal = ref(true)

function review(event: MouseEvent, entityId: string) {
  // A modified click opens a new tab, which takes the entity from the URL.
  if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
    return
  }
  showModal.value = false
  userStore.changeSession({ role: 'admin', entity_id: entityId })
}
</script>
